
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/Sparkline",
      function () {
        return require("private-next-pages/components/Sparkline.mdx");
      }
    ]);
  